import axios from 'axios'

const BASE_URL = 'http://127.0.0.1:9006'

export default class CommLabelPrintClient {
    constructor () {
        this.requests = axios.create({
            baseURL: BASE_URL,
            timeout: 200000,
            withCredentials: false
        })
    }

    /**
     * 调用本地 PrintService CommLabelPrint 接口打印标签
     *
     * @param {Object} params 打印参数
     * @param {string} params.PrintJobName 打印任务名
     * @param {string} params.Copies 打印份数
     * @param {string} params.TemplateName 标签模板文件名（.lax）
     * @param {Array<Object>} params.ListPrintValue 标签字段数据列表
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async printLabel (params) {
        return this.requests.post('/PrintService/CommLabelPrint', params, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/comp/lib/commLabelPrintClient.js